import { createFileRoute } from "@tanstack/react-router";
import { Hero } from "@/components/za-firme/Hero";
import { Benefits } from "@/components/za-firme/Benefits";
import { TrustChecklist } from "@/components/za-firme/TrustChecklist";
import { Testimonials } from "@/components/za-firme/Testimonials";
import { PublicFaqSection } from "@/components/public/faq/PublicFaqSection";
import { ssrPage } from "@/ssr/define-page";
import { definePageMeta } from "@/ssr/define-meta";
import { buildPageStructuredData } from "@/ssr/structured-data";

const zaFirmeMeta = definePageMeta({
  titleKey: "forCompanies.meta.title",
  descriptionKey: "forCompanies.meta.description",
  ogImage: "/og-companies.jpg",
  structuredData: (ctx) => buildPageStructuredData(ctx, {
    titleKey: "forCompanies.meta.title",
    descriptionKey: "forCompanies.meta.description",
    ogImage: "/og-companies.jpg",
    breadcrumbs: [
      { name: "Psihotron", path: "/" },
      { name: ctx.t("nav.forCompanies"), path: "/za-firme" },
    ],
    mainEntity: ({ url, t }) => ({
      "@type": "Service",
      "@id": `${url.origin}/za-firme#employee-mental-health-service`,
      name: t("forCompanies.meta.title"),
      description: t("forCompanies.meta.description"),
      serviceType: "Employee mental health program",
      provider: { "@id": `${url.origin}/#organization` },
      areaServed: {
        "@type": "Country",
        name: "Bosnia and Herzegovina",
      },
      url: `${url.origin}/za-firme`,
    }),
  }),
});

export const Route = createFileRoute("/za-firme")(
  ssrPage({
    component: ForCompaniesPage,
    sections: [PublicFaqSection],
    meta: zaFirmeMeta,
  }),
);

function ForCompaniesPage() {
  return (
    <>
      <Hero />
      <Benefits />
      <TrustChecklist />
      <Testimonials />
      <PublicFaqSection.Component
        placement="companies"
        copyKey="forCompaniesPage.faq"
        sectionId="faq"
        background="oklch(95.43% 0.0136 78.26)"
      />
    </>
  );
}
